import { Form, Input, DatePicker, Button, Switch } from 'antd'
import React from 'react'
import { formatDate } from "../../utils/date"; 

function Filters({ onSubmit,initialValues }) {
  const onFinish = (value) => {
    onSubmit({
      ...value,
      MinOrderCreatedDate: value.MinOrderCreatedDate ? formatDate(value.MinOrderCreatedDate,false,"") : undefined,
      MaxOrderCreatedDate: value.MaxOrderCreatedDate ? formatDate(value.MaxOrderCreatedDate,false,"") : undefined,
    })
  }
  return (
    <Form
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 14 }}
      initialValues={initialValues}
      layout="horizontal"
      onFinish={onFinish}
    >
      <Form.Item label="Min. Başlangıç Tarihi" name="MinOrderCreatedDate">
        <DatePicker />
      </Form.Item>
      <Form.Item label="Max. Başlangıç Tarihi" name="MaxOrderCreatedDate">
        <DatePicker />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Filtrele
        </Button>
      </Form.Item>
    </Form>
  )
}


export default Filters
